import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Código Pacote:", -1)
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Nome Pacote:", -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Código MO do Pacote:", -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Descrição do Pacote:", -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Máximo de Parcelas Exibidas:", -1)
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Parcelas Padrão Marcada:", -1)
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Itens fora do Pacote tem Acréscimo de %:", -1)
const _hoisted_20 = { class: "d-flex w-100 justify-content-end" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save text-white" }, null, -1)
const _hoisted_24 = {
  key: 1,
  class: "indicator-label"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle me-2" }, null, -1)

import {
  FamilyDetailView,
  ExhibitionLayout,
  PackageRevisionDetailView,
  Installment,
} from "@/models/CardapioModel";
import { reactive, watch, onMounted, ref } from "vue";
import { installment, updatePackage } from "@/services/CardapioService";
import { useStore } from "vuex";
import useAlert from "@/composables/Alert";
import useEmitter from "@/composables/Emmiter";
import Swal from "sweetalert2/dist/sweetalert2.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormPackage',
  props: {
    updatePackage: {}
  },
  setup(__props: any) {

const props = __props;

const ruleFormRef = ref();
const emitter = useEmitter();
const store = useStore();
const { showTimeAlert } = useAlert();
const codConcessionaria = localStorage.getItem("codConcessionaria");
const concessionariaSelected = ref("");
const optionInstallment = ref<Installment[]>([]);
const loading = reactive({
  submit: false,
  optionInstallment: false,
});
const form = reactive({
  codPacote: 0,
  packageName: "",
  codPacoteMo: "",
  description: "",
  maxParcela: 0,
  parcelaPadrao: 0,
  acrescimoAlacarte: "",
});

const rules = reactive({
  codPacote: [
    {
      required: true,
      message: "Por favor, preencha. O preenchimento é obrigatório.",
      trigger: "blur",
    },
  ],
  packageName: [
    {
      required: true,
      message: "Por favor, escolha um opção.",
      trigger: "blur",
    },
  ],
  codPacoteMo: [
    {
      required: true,
      message: "Por favor, escolha um opção.",
      trigger: "blur",
    },
  ],
  description: [
    {
      required: true,
      message: "Por favor, escolha um opção.",
      trigger: "blur",
    },
  ],
});

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      Swal.fire({
        title: "Deseja fazer alterações no pacote?",
        showCancelButton: true,
        confirmButtonText: "Salvar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        text: "As alterações serão refletidas no app assim que forem salvas.",
      }).then((result) => {
        if (result.isConfirmed) {
          handleSubmit();
        } else if (result.isDenied) {
        }
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};

onMounted(() => {
  getInstallment();
});

watch(
  () => props.updatePackage,
  (newValue) => {
    if (newValue) {
      form.packageName = newValue.namePackage;
      form.codPacote = newValue.codPacote;
      form.description = newValue.descricao;
      form.codPacoteMo = newValue.codMOPacote;
      form.maxParcela = Number(newValue.parcela);
      form.parcelaPadrao = Number(newValue.parcelaPadrao);
      form.acrescimoAlacarte = newValue.acrescimoAlacarte;
    }
  },
  { deep: true, immediate: true }
);

const handleSubmit = async () => {
  if (codConcessionaria && typeof codConcessionaria == "string") {
    const payload = {
      ...form,
      currentCodPacote: props.updatePackage.codPacote,
      codConcessionaria: codConcessionaria,
    };
    
    loading.submit = true;

    await updatePackage(payload)
      .then((r) => {
        showTimeAlert(r.message);
        emitter.emit("update-family", {});
      })
      .catch(() => {
        showTimeAlert("Não foi possível completar a solicitação", "error");
      })
      .finally(() => (loading.submit = false));
  }
};

const getInstallment = async () => {
  loading.optionInstallment = true;
  optionInstallment.value = await installment().finally(() => {
    loading.optionInstallment = false;
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: form,
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        "label-width": "auto",
        rules: rules
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_el_form_item, { prop: "codPacote" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.codPacote,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.codPacote) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_el_form_item, { prop: "packageName" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.packageName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.packageName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_el_form_item, { prop: "codPacoteMo" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.codPacoteMo,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.codPacoteMo) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_el_form_item, { prop: "description" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.description,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.description) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_el_form_item, { prop: "optionInstallment" }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_el_select, {
                    class: "w-100",
                    placeholder: "Escolha uma parcela",
                    modelValue: form.maxParcela,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.maxParcela) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionInstallment.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.idcardapio_parcelas,
                          label: item.parcela,
                          value: item.parcela
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])), [
                    [_directive_loading, loading.optionInstallment]
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_el_form_item, { prop: "parcelaPadrao" }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_el_select, {
                    class: "w-100",
                    placeholder: "Escolha uma parcela",
                    modelValue: form.parcelaPadrao,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.parcelaPadrao) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionInstallment.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.idcardapio_parcelas,
                          label: item.parcela,
                          value: item.parcela
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])), [
                    [_directive_loading, loading.optionInstallment]
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_el_form_item, { prop: "acrescimoAlacarte" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.acrescimoAlacarte,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.acrescimoAlacarte) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm background_btn_1 text-white",
              id: "kt_button_1",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (submitForm(ruleFormRef.value))),
              disabled: loading.submit
            }, [
              (!loading.submit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                    _hoisted_23,
                    _createTextVNode(" Salvar ")
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_24, [
                    _hoisted_25,
                    _createTextVNode(" Aguarde... ")
                  ]))
            ], 8, _hoisted_21)
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}
}

})